import Event from 'events';
import request from 'request';

const timeoutDuration = 30 * 1000; // 支付的超时时间，30s
const timerDuration = 1 * 1000;

class FeeInstall extends Event {
  constructor({hasBuy = false, extUuid}) {
    super();

    this.data = {
      hasBuy,
      extUuid,
      payTypeList: [],
    }

    this.taskTimer = null;

    this.install();
  }

  install() {
    this.getPayTypeDetail((isSuccess = true) => {
      isSuccess && this.startPay();
    });
  }

  startPay() {
    const { extUuid, payTypeList} = this.data;

    const payType = payTypeList[0];

    this.emit('start');

    request({
      url: request.api.installPaidExt,
      type: 'POST',
      data: {
        extUuid,
        paySource: 'web',
        channel: payType,
      },
    })
      .done(res => {
        if (res.code == 0) {
          this.startGetPayStatus(res.orderId);
        } else {
          this.emit('success')
        }
      })
      .fail(err => {
        this.emit('error', err);
      })
  }

  startGetPayStatus(orderId) {
    const { extUuid } = this.data;

    const startTime = Date.now();

    const requestStatus = cb => {
      request({
        url: request.api.detectIsBuySuccessful,
        data: {
          orderId,
          extUuid,
        },
      })
        .done(res => {
          const isSuccess = res;

          cb({
            isSuccess,
          });
        })
        .fail(err => {
          cb({err});
        })
    }

    this.taskTimer = setInterval(() => {
      if (Date.now() - startTime >= timeoutDuration) {
        clearInterval(this.taskTimer);

        this.emit('error', '支付失败，请重新尝试');
        return;
      }

      requestStatus(({isSuccess = false, err = ''}) => {
        if (isSuccess) {
          clearInterval(this.taskTimer);
          this.emit('success');
          return;
        }

        if (err) {
          clearInterval(this.taskTimer);
          this.emit('error', err);
        }
      });
    }, timerDuration)

  }

  getPayTypeDetail(cb) {
    const { extUuid } = this.data;

    const url = request.api.getExtExpenseAttr + `?extUuid=${extUuid}`;

    request({
      url,
      type: 'GET',
    })
      .done(res => {
        this.data.payTypeList = res;

        cb && cb();
      })
      .fail(err => {
        const isSuccess = false;
        cb && cb(isSuccess);

        this.emit('error', err);
      })
  }

  destory() {
    this.taskTimer && clearInterval(this.taskTimer);
  }
}

export default FeeInstall;